import { API_BASE_URL } from "../../config";

/**
 * The route (สาย) list for dropdowns/filters — from seller-module's route registry, not from auth users tagged
 * deliveryCar, so a route keeps showing after its auth account is switched off.
 * Returns the same row shape the old by-tags call gave ({ uid, username, nameuser }) so the pages that
 * consume it do not change: uid = route uid, username = route code (Tkice-NN), nameuser = route name.
 * Only routes that are in service are returned. `response` is the raw fetch Response (status handling stays
 * with the caller); `rows` is the mapped list ([] when the call failed).
 */
export async function fetchRouteRegistry(token) {
    const response = await fetch(`${API_BASE_URL}/seller/api/sales-routes`, {
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    });
    if (!response.ok) return { response, rows: [] };
    const data = await response.json();
    const rows = (Array.isArray(data) ? data : [])
        .filter((r) => r && r.active !== false)
        .map((r) => ({ uid: r.routeUid, username: r.code || r.routeUid, nameuser: r.name || r.routeUid }));
    return { response, rows };
}
